angular.module('psModule').directive('psRating', function() {
	return {
		restrict: 'E',
		scope: {
            value: '='
		},
		template:'<span uib-rating class="hidden-xs hidden-sm" ng-if="value" max="5" ng-model="value" read-only="true" titles="[\'\',\'\',\'\',\'\',\'\']"></span> <span class="hidden-md hidden-lg" ng-if="value">{{value}}</span> <span class="hidden-md hidden-lg max-risk-info" ng-if="value">(5)</span> <span ng-if="!value">-</span>'
	};
});
